export default async function dataURItoBlob(dataURI: string) {
	return fetch(dataURI).then(res => res.blob());
}
